type SectionHeadProps = {
  kicker?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  action?: string;
};

export default function SectionHead({ kicker, title, desc, align = "left", action }: SectionHeadProps) {
  const centered = align === "center";
  return (
    <div className={`flex flex-col gap-4 ${centered ? "items-center text-center" : ""}`}>
      {kicker && (
        <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.3em] text-primary-600 uppercase">
          <span className="h-px w-6 bg-primary-500" />
          {kicker}
          {centered && <span className="h-px w-6 bg-primary-500" />}
        </span>
      )}
      <div className="flex w-full flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <h2 className="font-heading text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
          {title}
        </h2>
        {action && (
          <a
            href="#"
            className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-sm font-medium text-foreground-600 hover:text-primary-600"
          >
            {action}
            <span className="flex h-6 w-6 items-center justify-center transition-transform group-hover:translate-x-1">
              <i className="ri-arrow-right-line text-base" />
            </span>
          </a>
        )}
      </div>
      {desc && (
        <p className={`max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${centered ? "mx-auto" : ""}`}>
          {desc}
        </p>
      )}
    </div>
  );
}